import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import SectionDashboardBlood from "../../../../components/Section/SectionDashboardBlood.jsx";
import SelectDateAddons from "./SelectDateAddOns.jsx";
import { useTheme } from "@mui/material";

export default function BloodAddonsWelcome() {

    const theme = useTheme();
    const isLight = theme.palette.mode === "light";

    // Define colors once
    const sectionColors = {
        section1: isLight ? "grey.C100" : "greydark.C900",
        section2: isLight ? "grey.C400" : "greydark.C900",
        section3: isLight ? "grey.C400" : "greydark.C975",
        section4: isLight ? "grey.C500" : "greydark.C970",
    };

    // Define sections as an array
    const sections = [
        { color: sectionColors.section1, content: <SelectDateAddons /> },
        { color: sectionColors.section2, content: null },
        { color: sectionColors.section3, content: null },
        { color: sectionColors.section4, content: null },
    ];

return (

    <PageProtectedLayout
      
      headline="BLOOD BIOMARKER - "
      specify="ADD ON PACKS"

      >

      {/* Main Page Content */}
      <div>
        <SectionDashboardBlood
          colorContainer="transparent"
          sections={sections}
          gap={0}      // spacing between sections
          padding={0}  // padding inside the container
        />
      </div>
      
    </PageProtectedLayout>

  );
}